const TotalPayable = ({ totalCost }) => (
  <div className="flex flex-row space-between">
    <p className="grow font-normal text-xl">TOTAL PAYABLE</p>
    <p className="text-right font-medium text-3xl">$ {totalCost}</p>
  </div>
);

export default TotalPayable;
